import { useParams } from "react-router";
import { useYard } from "./components";
import { YardLots } from "./yard-lots";
import { YardSettingsSection } from "./yard-settings-section";

/**
 * Nature des travaux step (from screen 903/905). Lots and their prestations
 * are managed through the single nested editable table (screen 905).
 */
export function YardNatureTravauxPage() {
  const { yardId } = useParams<{ yardId: string }>();
  const numericYardId = Number(yardId);
  const { yard } = useYard(numericYardId);

  return (
    <YardSettingsSection title="Nature des travaux">
      <YardLots
        yardId={numericYardId}
        inPreparation={yard?.inPreparation ?? false}
      />
    </YardSettingsSection>
  );
}
